var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "checkbox-container",
    class: {
      'three-column': _vm.hasMultipleColumns
    }
  }, [_vm._l(_vm.options, function (option) {
    return [_c('VCheckbox', {
      key: option.value,
      attrs: {
        "field-value": _vm.fieldValue(option),
        "label": option.text,
        "name": _vm.name + '-' + option.value
      },
      on: {
        "input": function (value) {
          return _vm.handleInput(value, option);
        }
      }
    })];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }